module.exports = __webpack_public_path__ + "media/tr_tr_s2_Emel.a27f8c4a.oga";